import { AdminSidebar } from '~/components/admin/admin-sidebar';
import { type UserResult } from '~/domain/users/models/user';
import { cn } from '~/styles/extended-theme';
import { displayName } from '~/utils/display-name';

import { Navbar } from '../nav/navbar';

import { Footer } from './footer';
import { PublicNavbar } from './public-navbar';

interface Props {
  userLayoutData: UserResult | null;
  showFooter?: boolean;
  fullWidth?: boolean; //Admin pages use full width, "athlete" pages have a max width (fullWidth=false)
  hideContentOverflow?: boolean; // Set to true for pages that have a sticky action bar (like the admin pages)
  children: React.ReactNode;
}

export function MainPageLayout({
  userLayoutData,
  showFooter = false,
  hideContentOverflow = false,
  children,
}: Props) {
  const { email, firstName, lastName, avatarUrl, permissions, roles, gymIds, athleteProfileId } =
    userLayoutData ?? {};
  const isFPAdmin = roles?.includes('FPAdmin') ?? false;

  return (
    <>
      <div
        className={cn(
          'grid h-full grid-cols-1',
          showFooter ? 'grid-rows-[auto_1fr_auto]' : 'grid-rows-[auto_1fr]',
        )}
      >
        {userLayoutData === null ? (
          <PublicNavbar />
        ) : (
          <Navbar
            email={email ?? ''}
            displayName={displayName(firstName, lastName)}
            avatarUrl={avatarUrl}
            className={isFPAdmin ? 'col-span-2' : ''}
            userPermissions={permissions ?? []}
            userGymIds={gymIds ?? []}
            athleteProfileId={athleteProfileId}
          />
        )}

        {isFPAdmin ? <AdminSidebar permissions={permissions} /> : null}
        <div
          className={cn(
            'size-full',
            hideContentOverflow ? 'overflow-hidden' : null,
            isFPAdmin ? 'pl-12' : null,
          )}
        >
          {children}
        </div>

        {showFooter ? <Footer className={isFPAdmin ? 'col-span-2' : ''} /> : null}
      </div>
    </>
  );
}
